export function NRLogo({ width = 46 }: { width?: number }) {
  const h = width * (40 / 46);
  return (
    <svg width={width} height={h} viewBox="0 0 48 32" fill="none" preserveAspectRatio="xMidYMid meet">
      <path d="M0 0H5.76C11.0619 0 15.36 4.47715 15.36 10V32H0V0Z" fill="var(--t-text)" />
      <path d="M16.32 0H22.08C27.3819 0 31.68 4.47715 31.68 10V32H16.32V0Z" fill="var(--t-text)" />
      <path d="M32.64 8C32.64 3.58172 36.0785 0 40.32 0C44.5615 0 48 3.58172 48 8C48 12.4183 44.5615 16 40.32 16C36.0785 16 32.64 12.4183 32.64 8Z" fill="var(--t-text)" />
    </svg>
  );
}
